// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteModelResponse {
    static getAttributeTypeMap() {
        return SiteModelResponse.attributeTypeMap;
    }
}
SiteModelResponse.discriminator = undefined;
SiteModelResponse.additionalProperties = false;
SiteModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "SiteModel"
    },
];
//# sourceMappingURL=siteModelResponse.js.map